module.exports = __webpack_public_path__ + "static/media/im.3e016d11.svg";